import { ReactNode } from 'react';

import styles from './FormFieldset.module.scss';
import { PageSection } from '@/components/ui/PageSection';
import type { PageSectionProps } from '@/components/ui/PageSection';

interface FormFieldsetProps extends Omit<
  PageSectionProps,
  'title' | 'children'
> {
  legend: string;
  children: ReactNode;
}
export const FormFieldset = ({
  legend,
  children,
  ...pageSectionProps
}: FormFieldsetProps) => {
  return (
    <fieldset className={styles.FieldsetDefaultStyleReset} aria-label={legend}>
      <PageSection
        title={legend}
        titleComponentType="legend"
        {...pageSectionProps}
      >
        {children}
      </PageSection>
    </fieldset>
  );
};
